"use client";

import React from "react";
import { ArrowRight, Compass } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { Reveal } from "@/components/cosmic/Reveal";
export default function MultiverseAtlas() {
  return <section id="multiverse-atlas" data-nav="dark" className="relative py-16 sm:py-20 lg:py-28 w-full max-w-full overflow-x-clip text-foreground">
      <div className="relative z-10 mx-auto max-w-[76rem] w-full px-4 sm:px-6">
        {/* Subtle Section hairline separator */}
        <div className="ql-divider mb-16" aria-hidden="true" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          {/* Columns 1-5: Section narrative & pathway button */}
          <div className="lg:col-span-5 flex flex-col items-start">
            <Reveal>
              {/* Signature node element */}
              <div className="flex items-center gap-2 mb-4 font-mono text-xs font-semibold tracking-widest text-primary uppercase">
                <Compass className="size-3.5" />
                <span>THEORETICAL COSMOLOGY</span>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground font-serif leading-tight">
                Cosmic Structures & Branching Hypotheses
              </h2>

              <p className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed font-sans">
                Modern cosmology suggests our observable horizon may be one bubble in an endless inflationary sea. Explore the mathematical foundations that suggest our reality could branch into infinite cosmic configurations.
              </p>

              <div className="mt-8 w-full sm:w-auto">
                <Link to="/MultiverseAtlasPage" className="ql-btn w-full sm:w-auto min-h-[44px] justify-center">
                  <span>Enter the Multiverse Atlas</span>
                  <ArrowRight className="size-4 shrink-0" />
                </Link>
              </div>
            </Reveal>
          </div>

          {/* Columns 6-12: Framed visual portal showcase */}
          <div className="lg:col-span-7">
            <Reveal delay={120}>
              <div className="relative rounded-2xl p-2 sm:p-3 ql-glass-strong shadow-2xl">
                <div className="overflow-hidden rounded-xl bg-card/60 relative border border-border/50">
                  <AspectRatio ratio={16 / 10} className="w-full">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1830392/img/multiverse_branching_cosmic_web.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1830392/img/multiverse_branching_cosmic_web.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1830392/img/multiverse_branching_cosmic_web.png-wvc-sizes" alt="Complex branching cosmic web with luminous filaments linking galactic clusters" width={1600} height={1000} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
                  </AspectRatio>
                </div>

                {/* Inset horizon hairline decoration */}
                <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" aria-hidden="true" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}